import { SessionContext } from '@/context/SessionContext';
import { Box, Group, Paper, SimpleGrid, Text, useMantineTheme } from '@mantine/core';
import { useContext } from 'react';


const StatHeader: React.FC = () => {
	const theme = useMantineTheme()
	const session = useContext(SessionContext)


	if (!session) {
		return null;
	}

	const artistStats = session.artistStats;

	if (!artistStats) {
		return <Text>Loading artist stats...</Text>;
	}

	const paperSx = {
		boxShadow: "0px 0px 10px 1px #334F73",
		borderColor: theme.colors.blue[0],
		transition: "box-shadow 0.3s, filter 0.3s, transform 0.3s",
		"&:hover": {
			boxShadow: `0 0 25px 4px ${theme.colors.blue[4]}, 0 0 10px 5px ${theme.colors.blue[3]}`,
			filter: "brightness(1.15)",
			transform: "scale(1.02)"

		},
	};

	const grid = (
		<>
			<Paper
				p="md"
				radius="md"
				bg={theme.colors.blue[7]}
				w={250}
				shadow={"lg"}
				withBorder
				sx={paperSx}
			>
				<Group justify="space-between">
					<Text
						size="md"
						c={theme.colors.blue[0]}
					>
						Users
					</Text>
				</Group>

				<Group align="flex-end" gap="xs" mt={25}>
					<Text
						c={theme.colors.blue[0]}
						fw={700}
						size="xl"
					>
						{artistStats?.userCount}
					</Text>
				</Group>

				<Text
					fz="xs"
					mt={7}
					c={theme.colors.blue[0]}
				>
					Total users who've used your song(s) in a project submission
				</Text>
			</Paper>
			<Paper
				p="md"
				radius="md"
				bg={theme.colors.blue[7]}
				w={250}
				withBorder
				sx={paperSx}
			>
				<Group justify="space-between">
					<Text
						size="md"
						c={theme.colors.blue[0]}
					>
						Schools
					</Text>
				</Group>

				<Group align="flex-end" gap="xs" mt={25}>
					<Text
						c={theme.colors.blue[0]}
						fw={700}
						size="xl"
					>
						{artistStats?.classroomCount}
					</Text>
				</Group>

				<Text
					fz="xs"
					mt={7}
					c={theme.colors.blue[0]}
				>
					Total schools that contain users of your songs
				</Text>
			</Paper>
			<Paper
				p="md"
				radius="md"
				bg={theme.colors.blue[7]}
				w={250}
				withBorder
				sx={paperSx}
			>
				<Group justify="space-between">
					<Text
						size="md"
						c={theme.colors.blue[0]}
					>
						Measures
					</Text>
				</Group>

				<Group align="flex-end" gap="xs" mt={25}>
					<Text
						c={theme.colors.blue[0]}
						fw={700}
						size="xl"
					>
						{
							artistStats.songs.reduce(
								(total, song) =>
									total +
									(song.submissionUsage
										? song.usage.reduce((sum, submission) => sum + (submission.measuresUsed || 0), 0)
										: 0),
								0
							)
						}
					</Text>
				</Group>

				<Text
					fz="xs"
					mt={7}
					c={theme.colors.blue[0]}
				>
					Total measures currently in active projects
				</Text>
			</Paper>
		</>
	);

	return (
		<Box>
			<SimpleGrid cols={{ base: 1, xs: 3, md: 3 }}>{grid}</SimpleGrid>
		</Box>
	);

}

export default StatHeader
